import { keepPreviousData } from "@tanstack/react-query";
import { useCallback } from "react";
import { useNavigate } from "react-router";

import { StatCard } from "@design-system/StatCard/StatCard";

import { routes } from "@pages/routes";

import { useClientEmployeeOwnedApplicationsCountQuery } from "./EmployeeOwnedAppsCountStat.g";

type Props = {
  clientEmployeeId: string;
  clientId: string;
};

export const EmployeeOwnedAppsCountStat = ({
  clientEmployeeId,
  clientId,
}: Props) => {
  const navigate = useNavigate();

  const { data, isLoading } = useClientEmployeeOwnedApplicationsCountQuery(
    {
      clientId,
      businessOwnerId: clientEmployeeId,
    },
    {
      placeholderData: keepPreviousData,
    },
  );

  const ownedAppCount = data?.clientApplications?.totalCount ?? 0;

  const handleOpenOwnedApplications = useCallback(() => {
    navigate(
      routes.portal.clients.client.clientEmployees.clientEmployee.ownedApplications.$buildPath(
        {
          params: { clientId, clientEmployeeId },
        },
      ),
    );
  }, [clientEmployeeId, clientId, navigate]);

  return (
    <StatCard
      icon="faUserTie"
      title="Owned applications"
      value={ownedAppCount.toString()}
      isLoading={isLoading}
      onOpenDetails={handleOpenOwnedApplications}
    />
  );
};
